export const blockIconsPhotoandimageCropNew = (
	<span className='material-symbols-outlined'>crop</span>
);
